import { Alert } from 'reactstrap';
import React, { FunctionComponent, useState } from 'react';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { compose } from 'recompose';
import { withTranslation, WithTranslation } from 'react-i18next';

// components
import { ReportType, ReactApiDataActions } from 'constants/api';
import FormModal from './FormModal';

interface InputProps {
    report: ReportType;
    pageNumber: number;
    perPage: number;
    sortBy: string;
    sortOrder: string;
    renderButton: (renderProps: { onClick: () => void }) => void;
}
interface EnhanceProps {
    deleteReport: ApiDataBinding<{ data: ReportType }>;
    apiDataActions: ReactApiDataActions;
}

type Props = EnhanceProps & InputProps & WithTranslation;

const enhance = compose<Props, InputProps>(
    withApiData({
        deleteReport: 'deleteReport',
    }),
    withTranslation()
);

type FormValues = Pick<ReportType, 'name'>;

const ReportDeleteModal: FunctionComponent<Props> = ({
    report,
    pageNumber,
    perPage,
    sortBy,
    sortOrder,
    deleteReport,
    apiDataActions,
    renderButton,
    t,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }
    function onSubmit(values: FormValues) {
        return deleteReport.perform({ reportUuid: report.uuid });
    }

    function onSucces() {
        apiDataActions.invalidateCache('getReports');
        apiDataActions.perform('getReports', {
            page: pageNumber,
            per_page: perPage,
            sort: sortBy,
            order: sortOrder,
        });
    }

    const reportName = report.name;

    return (
        <React.Fragment>
            <FormModal
                header={t('reportsModals.deleteModalTitle', { reportName })}
                isOpen={isOpen}
                toggle={toggle}
                initialValues={{
                    name: report.name,
                }}
                onSubmit={onSubmit}
                onSuccess={onSucces}
                successMessage={t('notification.deleteReportSuccessful')}
            >
                {() => (
                    <React.Fragment>
                        <Alert color="warning" className="mb-0">
                            <strong>{t('common.warning')}</strong>
                            <p>{t('reportsModals.deleteWarningMessage')}</p>
                        </Alert>
                    </React.Fragment>
                )}
            </FormModal>
            {renderButton({ onClick: toggle })}
        </React.Fragment>
    );
};

export default enhance(ReportDeleteModal);
